<template>
  <nx-entity-unpublish-action v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import NxEntityUnpublishAction from '@/modules/entity/actions/EntityUnpublishAction';

export default {
  components: { NxEntityUnpublishAction },
};
</script>
